import {Box} from '@mui/material';
import {t} from 'i18next';
import React, {LegacyRef, useState} from 'react';
import {
  RuleGroupBodyComponents,
  RuleGroupProps,
  useRuleGroup,
  useStopEventPropagation,
} from 'react-querybuilder';
import {POPUP_BUTTON_STYLE} from '../../../constants/constants';
import AurButton from '../../common/aur-button/AurButton';
import AurIcon, {IconNames} from '../../common/aur-icon/AurIcon';
import AurPopup from '../../common/aur-popup/AurPopup';

const CustomGroup: React.FC<RuleGroupProps> = (props) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const rg = useRuleGroup(props);

  const addRuleGroup = useStopEventPropagation(rg.addGroup);
  const removeRuleGroup = useStopEventPropagation(rg.removeGroup);
  const confirmDelete = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div ref={rg.dropRef}>
        <div
          // Attach the previewRef for drag preview
          ref={rg.previewRef}
          title={rg.accessibleDescription}
          className={rg.outerClassName}
          data-dragmonitorid={rg.dragMonitorId}
          data-dropmonitorid={rg.dropMonitorId}
          data-rule-group-id={rg.id}
          data-level={rg.path.length}
          data-path={JSON.stringify(rg.path)}
        >
          <div className={rg.classNames.header}>
            <div
              ref={rg.dragRef as LegacyRef<HTMLDivElement> | undefined}
              className="draggable-icon-container"
            >
              <rg.schema.controls.dragHandle />
            </div>
          </div>
          {/* Body: renders child rules or groups */}
          <div
            className={rg.classNames.body}
            data-order-path={`${props.path.length % 3}`}
          >
            <RuleGroupBodyComponents {...rg} />
            {rg.path.length > 0 ? (
              <Box className="group-action-btn-container">
                <AurButton
                  type="secondary"
                  size={'Small'}
                  onClick={addRuleGroup}
                  classNames="buttonSmall_Size"
                  startIcon={
                    <AurIcon
                      icon={IconNames.LogicIcon}
                      customClassName={'add-logic-icon'}
                    />
                  }
                  label={t('queryBuilder.logicGroup')}
                />
                <AurButton
                  type="secondary"
                  onClick={
                    rg.ruleGroup.rules.length ? confirmDelete : removeRuleGroup
                  }
                  ariaLabel={t('queryBuilder.deleteRuleGroup')}
                  classNames="buttonSmall_Size group-action-icon-button"
                  startIcon={<AurIcon icon={IconNames.Remove} />}
                />
              </Box>
            ) : null}
          </div>
        </div>
      </div>
      {showModal ? (
        <AurPopup
          className="delete-confirmation-popup"
          open={showModal}
          onOk={removeRuleGroup}
          onCancel={closeModal}
          showPopupHeading={true}
          showCloseIcon={true}
          buttonStyle={POPUP_BUTTON_STYLE.STACKED}
          popupHeading={t('queryBuilder.deleteLogicGroupPopup.heading')}
          popupContent={t('queryBuilder.deleteLogicGroupPopup.description')}
          labelActionCancel={t(
            'queryBuilder.deleteLogicGroupPopup.cancelButton'
          )}
          labelActionOk={t('queryBuilder.deleteLogicGroupPopup.deleteButton')}
        />
      ) : null}
    </>
  );
};

export default CustomGroup;
